import e from"react";var t=e.createContext({expandedFiltersList:[],setExpandedFiltersList:function(e){console.log(e)}});export{t as FilterCategoriesExpansion};
